import { memo, useCallback } from 'react';
import { Box, Button, Text } from '@bonanza-social/moonlight';
import { ConfirmationProps } from './Confirmation.types';

function Confirmation({
  title,
  titleNS,
  titleKey,
  description,
  descriptionNS,
  descriptionKey,
  confirmButton,
  confirmButtonNS = 'common',
  confirmButtonKey = 'confirm',
  cancelButton,
  cancelButtonNS = 'common',
  cancelButtonKey = 'cancel',
  onConfirm,
  close,
}: ConfirmationProps) {
  const handleConfirm = useCallback(() => {
    onConfirm();
    close();
  }, [onConfirm, close]);

  return (
    <Box gap="space-400">
      <Text
        variant="h5"
        locNS={titleNS}
        locKey={titleKey}
        color="darkSurfacePrimary"
      >
        {title}
      </Text>
      <Text
        variant="body-m"
        locNS={descriptionNS}
        locKey={descriptionKey}
        color="darkSurfacePrimary"
      >
        {description}
      </Text>
      <Box flexDirection="row" marginTop="space-200" gap="space-300">
        <Button
          flex={1}
          variant="secondary"
          locNS={cancelButtonNS}
          locKey={cancelButtonKey}
          text={cancelButton}
          onPress={close}
        />
        <Button
          flex={1}
          locNS={confirmButtonNS}
          locKey={confirmButtonKey}
          text={confirmButton}
          onPress={handleConfirm}
        />
      </Box>
    </Box>
  );
}

export default memo(Confirmation);
